import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MobileAppSliceState {
  hasEnteredThroughDeepLink: boolean;
}

const initialState: MobileAppSliceState = {
  hasEnteredThroughDeepLink: false
};

const mobileAppSlice = createSlice({
  name: "mobileApp",
  initialState,
  reducers: {
    setHasEnteredThroughDeepLink: {
      reducer: (state, action: PayloadAction<{ hasEnteredThroughDeepLink: boolean }>) => {
        state.hasEnteredThroughDeepLink = action.payload.hasEnteredThroughDeepLink;
      },
      prepare: (hasEnteredThroughDeepLink: boolean = false) => ({
        payload: { hasEnteredThroughDeepLink }
      })
    }
  }
});

export default mobileAppSlice;
